export default "__VITE_ASSET__CrPtROTA__"